import { render } from "./makedir.vue?vue&type=template&id=67f8ddb9"
import script from "./makedir.vue?vue&type=script&lang=js"
export * from "./makedir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__